export default __webpack_public_path__ + "static/media/nationalIdBR.54dc9931.png";